enum JobAdSkillsType {
    HardSkill = 'HardSkill',
    SoftSkill = 'SoftSkill',
}

export default JobAdSkillsType;
